/* eslint-disable indent */
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Input from '@deprecated-ui/common/Input';
import ModalAntd from '@deprecated-ui/common/Modal';
import color from '@deprecated-ui/_style/color';
import device from '@deprecated-ui/_style/device';
import styled, { css } from 'styled-components';

const Modal = styled(ModalAntd).attrs({
  zIndex: 1050,
  transitionName: '',
  maskTransitionName: '',
})`
  .ant-modal-content {
    border-radius: 3px;
  }
  .ant-modal-header {
    padding: 0 20px !important;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    height: 40px;
    border-bottom: solid 1px ${color.gainsboro};

    ${({ noBorder }) =>
      noBorder &&
      css`
        border: none;
      `}
  }
  .ant-modal-body {
    padding: 20px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .ant-modal-footer {
    padding: 0 !important;
    text-align: left;
    display: flex;

    button:first-child {
      border-radius: 0 0 0 3px;
    }
    button:last-child {
      border-radius: 0 0 3px 0px;
    }
  }
  .ant-modal-close-x {
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-size: 12px;
  }
`;

const Select = styled.select`
  padding: 8px;
  line-height: 14px;
  width: 100%;
  border-radius: 2px;
  font-size: 14px;
  margin: 5px 0;
  border: 1px solid ${color.gainsboro};
`;

const Option = styled(Text).attrs({ as: 'option' })``;

const TextArea = styled(Input.TextArea)`
  margin: 5px 0;
`;

// Will be replaced by icon from ui-design
const IconMedia = styled(Flex).attrs((props) => ({
  background: props.background || 'none',
  align: 'center',
  justify: 'center',
}))`
  background-color: ${(props) => props.background};
  border-radius: 50%;
  width: 45px;
  height: 45px;
  margin-right: 10px;
  cursor: pointer;
  img {
    background: none;
    padding: 10px;
    width: 100%;
    height: 100%;
  }
`;

const ModalFullscreen = styled(Modal).attrs({
  type: 'fullscreen',
})`
  .ant-modal-content {
    width: 100%;
  }
  .ant-modal-header {
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ant-modal-close-x {
    font-size: 20px;
    color: #000;
    weight: bold;
  }
  .ant-modal-close {
    right: 32px;
    top: 15px;
    font-weight: bold;
  }

  .ant-modal-body {
    height: calc(100vh - 60px);
  }

  @media ${device.tablet} {
    .ant-modal-content {
      width: 660px;
    }
  }
`;

export { Modal, Select, Option, TextArea, IconMedia, ModalFullscreen };
